import { useContext, useEffect, useState } from "react";
import "./restaurant-current.styles.scss";
import { OrdersContext } from "../../../contexts/orders.context";
import { AccountsContext } from "../../../contexts/accounts.context";
const RestaurantCurrent = () => {
  const [takeawayCount, setTakeawayCount] = useState(0);
  const { tableCount, totalTables, takeawayOrders, totalRevenue } =
    useContext(OrdersContext);
  const { totalAccounts } = useContext(AccountsContext);
  useEffect(() => {
    setTakeawayCount(Object.keys(takeawayOrders).length);
  }, [takeawayOrders]);
  return (
    <div className="restaurant-current-container">
      <div className="restaurant-current-boxes">
        <div className="restaurant-current-box tables-box">
          <span className="tables-box-title">Occupancy</span>
          <span className="tables-box-details">
            {tableCount}/{totalTables}
          </span>
        </div>
        <div className="restaurant-current-box takeaway-box">
          <span className="takeaway-box-title">Active Takeaway Orders</span>
          <span className="takeaway-box-details">{takeawayCount}</span>
        </div>
        <div className="restaurant-current-box revenue-box">
          <span className="revenue-box-title">Total Revenue</span>
          <span className="revenue-box-details">{totalRevenue}</span>
        </div>
        <div className="restaurant-current-box accounts-box">
          <span className="accounts-box-title">Active Accounts</span>
          <span className="accounts-box-details">{totalAccounts}</span>
        </div>
      </div>
    </div>
  );
};
export default RestaurantCurrent;
